const products = [
  {
    id: 'barista-espresso',
    slug: 'barista-espresso',
    name: 'Tchibo Barista Espresso',
    nameHebrew: 'צ׳יבו בריסטה אספרסו (1 ק״ג)',
    description: 'פולי קפה בקלייה מסורתית איטית, בעלי ארומה עשירה וקרמה מושלמת. 100% פולי ערביקה.',
    longDescription:
      'פולי קפה צ׳יבו בריסטה אספרסו נקלים בתהליך איטי ומסורתי שמביא לעוצמה מלאה ולארומה עמוקה של שוקולד מריר וקינמון. הקלייה הכהה מעניקה גוף כבד, קרמה עבה וסיומת ארוכה — בדיוק כמו באיטליה.',
    price: 115,
    intensity: 5,
    image: '/tchibo-barista-espresso-1kg-coffee.png',
    tastingNotes: ['שוקולד מריר', 'קינמון', 'אגוזים קלויים'],
    bestWith: [
      'עוגת שוקולד כהה או טירמיסו',
      'קרואסון חמאה טרי',
      'ביסקוטי שקדים',
    ],
    roast: 'קלייה כהה',
    origin: 'תערובת ערביקה מובחרת מדרום אמריקה ואפריקה',
    preparation: 'מכונת אספרסו, מוקה, פרנץ׳ פרס',
  },
  {
    id: 'crema-vollmundig',
    slug: 'crema-vollmundig',
    name: 'Tchibo Caffè Crema Vollmundig',
    nameHebrew: 'צ׳יבו קפה קרמה פולמונדיג (1 ק״ג)',
    description: 'הטעם הגרמני הקלאסי. קפה מאוזן עם גוף מלא וסיומת עדינה של שוקולד מריר.',
    longDescription:
      'הקפה הגרמני הקלאסי של צ׳יבו — Vollmundig פירושו "מלא בפה". קלייה בינונית-כהה שמשלבת גוף עגול ומלא עם סיומת חלקה של שוקולד חלב ותבלינים. מושלם למי שמחפש כוס קפה מאוזנת שמתאימה לכל שעה ביום.',
    price: 115,
    intensity: 4,
    image: '/tchibo-vollmundig-kl.png',
    tastingNotes: ['שוקולד חלב', 'תבלינים', 'קרמל'],
    bestWith: [
      'ארוחת בוקר ישראלית — חלה, גבינות ופירות',
      'עוגת גבינה אפויה',
      'שטרודל תפוחים',
    ],
    roast: 'קלייה בינונית-כהה',
    origin: 'תערובת ערביקה ממרכז ודרום אמריקה',
    preparation: 'מכונת אספרסו, פילטר, פרנץ׳ פרס',
  },
  {
    id: 'barista-crema',
    slug: 'barista-crema',
    name: 'Tchibo Barista Caffè Crema',
    nameHebrew: 'צ׳יבו בריסטה קפה קרמה (1 ק״ג)',
    description: 'קליית בריסטה עדינה לפולי ערביקה נבחרים, המעניקה טעם פירותי עדין וקרמה קטיפתית.',
    longDescription:
      'קלייה בינונית ובהירה שנותנת לפולי הערביקה לבטא את הטעמים הפירותיים הטבעיים שלהם. קרמה קטיפתית ועדינה, חומציות נעימה, ותחושה קלילה בפה. הקפה האידיאלי לשעות הבוקר המוקדמות ולמי שמעדיף טעם עדין ומתוחכם.',
    price: 115,
    intensity: 3,
    image: '/crema.png',
    tastingNotes: ['פירות יער', 'דבש', 'שקדים'],
    bestWith: [
      'מאפה שמרים עם שוקולד לבן',
      'פנקייקים עם מייפל ופירות טריים',
      'עוגיות חמאה',
    ],
    roast: 'קלייה בינונית',
    origin: 'פולי ערביקה נבחרים מאתיופיה וקולומביה',
    preparation: 'מכונת אספרסו, פילטר, קמקס',
  },
];

export function getProductBySlug(slug) {
  return products.find((p) => p.slug === slug);
}

export default products;
